import React, { ReactElement } from 'react';
import { ReactComponent as Loader } from 'assets/svgs/loading.svg';
import './styles.scss';

export default function PageLoader(): ReactElement {
  return (
    <div className='page-loader'>
      <Loader />
    </div>
  );
}
